<script>
import { mapActions, mapGetters } from 'vuex'
import * as modes from '@/constants/modes'
import currency from '../../filters/currency'

export default {
  props: {
    /**
     * @type {import('@/types/Participant.js').Participant}
     */
    participant: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'mode',
      'hasFeature'
    ]),
    modes() {
      return modes
    }
  },
  methods: {
    ...mapActions([
      'donate'
    ]),
    /**
     * @param amount {Number|null}
     */
    formatCurrency(amount) {
      const { locale } = this.$i18n
      if (!amount) return currency(0, locale)
      return currency(amount, locale)
    }
  }
}
</script>

<template>
  <div
    class="bg-primary card text-white text-center p-3"
    style="gap:8px"
  >
    <h4
      class="text-white"
      v-text="$t('donate.header')"
    />
    <p
      class="w-50 mx-auto bold-currency font-weight-normal"
      v-html="
        $t('donate.participant.raised',{
          name: participant.firstname,
          amount: formatCurrency(participant.raised.eur || 0)
        })
      "
    />
    <a
      v-if="hasFeature('boostRunner') && mode !== modes.POST"
      href="#"
      class="btn btn-outline-light"
      @click.prevent="donate({ participantId: participant.id, distance: true })"
    >
      {{ $t('donate.distance.btn') }}
    </a>
  </div>
</template>

<style scoped lang="scss">
.bold-currency ::v-deep(b) {
  font-size: $h1-font-size;
}
</style>
